import React from 'react';
import { AuthorityType, AuthorityLevel } from '../../types';
import { useUser } from '../../hooks/authentication';
import { StyledTextButton } from '../styled'; // Adjust the import path according to your file structure

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  authorityType: AuthorityType;
  authorityLevel: AuthorityLevel;
}

const RestrictedStyledTextButton: React.FC<Props> = (props) => {
  const { userHasAuthority } = useUser();

  const { authorityType, authorityLevel, children, ...buttonProps } = props;

  if (!userHasAuthority(authorityType, authorityLevel)) {
    return null;
  }

  return <StyledTextButton {...buttonProps}>{children}</StyledTextButton>;
};

export default RestrictedStyledTextButton;
